import { Component, input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { HomeComponent } from '../pages/home/home.component';
import { ExistingOrderComponent } from '../pages/existing-order/existing-order.component';
import { AccountComponent } from '../pages/account/account.component';
import { Order } from '../shared/classes/order';
import { Supplier } from '../shared/classes/supplier';
import { View } from '../shared/classes/view.enum';

@Component({
    selector: 'app-shell',
    templateUrl: './app-shell.component.html',
    styleUrls: ['./app-shell.component.css'],
    imports: [HeaderComponent, DashboardComponent, HomeComponent, ExistingOrderComponent, AccountComponent]
})
export class AppShellComponent {
    readonly orders = input.required<Order[]>();
    readonly supplier = input.required<Supplier>();

    public readonly views: typeof View = View;
    public view: View = View.HOME;
    public selectedOrder: Order | null = null;

    changeView(view: View): void {
        this.view = view;
    }
}
